import axios from 'axios'
import { Message } from 'element-ui'

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || '/api', // 从环境变量读取，默认使用代理
  timeout: 30000,
  withCredentials: true  // 允许跨域携带 cookie/session
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    // 在请求发送前做一些处理
    const token = localStorage.getItem('token')
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    // 自动注入数据隔离ID到请求头
    const isolationHeaders = {
      'X-Platform-Id': localStorage.getItem('platformId'),
      'X-City-Id': localStorage.getItem('cityId'),
      'X-Group-Id': localStorage.getItem('groupId'),
      'X-Property-Id': localStorage.getItem('propertyId'),
      'X-Community-Id': localStorage.getItem('communityId')
    }
    Object.keys(isolationHeaders).forEach(key => {
      const val = isolationHeaders[key]
      if (val) {
        // 安全编码：HTTP headers 只允许 ASCII，中文等非 ASCII 值需编码
        config.headers[key] = /^[\x00-\x7F]+$/.test(val) ? val : encodeURIComponent(val)
      }
    })
    // 运营商后台接口携带 operatorId
    const cityOperatorId = localStorage.getItem('cityOperatorId')
    if (cityOperatorId) {
      config.headers['X-Operator-Id'] = /^[\x00-\x7F]+$/.test(cityOperatorId) ? cityOperatorId : encodeURIComponent(cityOperatorId)
    }
    return config
  },
  error => {
    // 请求错误处理
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    // 如果返回的状态码为 0，或者 success 为 true，说明接口请求成功
    if (res.code === 0 || res.success === true) {
      return res
    } else {
      // 统一提示错误信息（_silent 跳过）
      const errorMsg = res.message || res.msg || '请求失败'
      if (!response.config._silent) {
        Message.error(errorMsg)
      }
      return Promise.reject(new Error(errorMsg))
    }
  },
  error => {
    // _silent: 静默失败，不弹错误提示
    const silent = error.config && error.config._silent

    // 处理 HTTP 错误状态码
    let errorMsg = '网络错误，请稍后重试'
    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMsg = '登录已过期，请重新登录'
          // 清除所有登录状态
          localStorage.removeItem('token')
          localStorage.removeItem('isLogin')
          localStorage.removeItem('userType')
          window.location.href = '/login'
          break
        case 403:
          errorMsg = '没有权限访问该资源'
          break
        case 404:
          // 不弹错误提示，由调用方的 .catch() 自行处理
          return Promise.reject(error)
        case 500:
          errorMsg = '服务器内部错误'
          break
        default:
          errorMsg = `请求失败 (${error.response.status})`
      }
    } else if (error.message.includes('timeout')) {
      errorMsg = '请求超时，请检查网络'
    }
    console.error('[request] Error for', error.config?.url, '| silent:', silent, '| hasResponse:', !!error.response, '| msg:', errorMsg)
    if (!silent) {
      Message.error(errorMsg)
    }
    // 兜底：HTTP 错误 + 有登录态 → session 可能过期，跳转登录
    if (error.response && localStorage.getItem('isLogin')) {
      localStorage.removeItem('isLogin')
      localStorage.removeItem('token')
      localStorage.removeItem('userType')
      setTimeout(() => { window.location.href = '/login' }, 1500)
    }
    return Promise.reject(error)
  }
)

export default request
